<template>
    <div v-if="modalData.status !== ResponseStatus.success">
        {{ $t('Something went wrong. Please try again') }}
    </div>
    <div v-else>
        <div>{{ $t('successfully withdrawn') | capitalize }}</div>
        <div>{{ $t('code to validate withdrawal in agency') | capitalize }}</div>
        <div>{{ modalData.transactionCode }}</div>
        <div>
            {{ $t('Do not forget to write down the code! To raise money, we expect you ' +
                'on {date} at the selected agency. Money can be picked up during the agencies\' program. ' +
                'Please observe the withdrawal period.', {
                date
            })
            }}
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { ResponseStatus } from '@core/models/user/withdrawal/enums';
    import { formatDateTime } from '@modules/shared/filters';

    export default {
        name: 'ShopWithdrawalResponseModal',
        created() {
            this.ResponseStatus = ResponseStatus;
        },
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
            date() {
                return formatDateTime(this.modalData.withdrawalDate, 'ddmmyyyy');
            }
        },
    };
</script>

<style>
    .withdrawal_modal {
        width: 800px;
        max-width: 800px;
        max-height: 1400px;
    }
</style>



// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/withdrawal/ShopWithdrawalResponseModal.vue